import { SplideSlide } from "@splidejs/react-splide";
import { AnimationSpec } from "chart.js";
import { _DeepPartialObject } from "chart.js/types/utils";
import { ReactNode } from "react";
import { Doughnut } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { localizeNumbers } from "../../../functions";

export interface ISliderProps {
  total: number;
  remind: number;
  backgroundColor: [string, string];
  title: string;
  innerText: string;
  footer?: ReactNode;
  isNgnService: boolean;
  postfix?: string;
}

export default function Slider({
  total,
  isNgnService,
  remind,
  postfix,
  backgroundColor,
  title,
  innerText,
  footer,
}: ISliderProps) {
  const chartData = {
    datasets: [
      {
        data: getSlideData(total, remind),
        backgroundColor: backgroundColor,
        hoverBackgroundColor: backgroundColor,
        borderWidth: 0,
      },
    ],
  };

  const [showTooltip, setShowTooltip] = useState(false);
  const handleIconClick = () => {
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
    }, 3000);
  };
  return (
    <SplideSlide>
      <div className="h-100 d-flex flex-column mx-2 px-2 py-3">
        <div className="d-flex text-center">
          <div className="flex-grow-1 mb-3">
            <div className="text-nowrap text-100 text-dark-l2">
              {title}
              <br />
              {footer}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center mb-4">
          <div className="align-self-center pos-rel mb-4">
            <Doughnut data={chartData} options={getOptions()} />
            <span className="position-center text-600 text-110 text-dark-tp4">
              {`${innerText} `}
              {postfix != null && (
                <small>
                  <FontAwesomeIcon
                    icon={"info"}
                    className="text-blue"
                    onClick={handleIconClick}
                  />
                </small>
              )}
              {!isNgnService && showTooltip && (
                <span className="tooltip">
                  <p>
                    <h5>
                      باقیمانده در صورت مصرف ترافیک پیام رسان داخلی:
                      {localizeNumbers(`${Math.round(remind * 4)} ${postfix}`)}
                    </h5>
                    <h5>
                      باقیمانده در صورت مصرف ترافیک داخلی:
                      {localizeNumbers(
                        `${Math.round(remind * 2.7)} ${postfix}`
                      )}
                    </h5>
                  </p>
                </span>
              )}
            </span>
          </div>
        </div>
      </div>
    </SplideSlide>
  );
}

function getSlideData(total: number, remind: number) {
  const remindPercent = (remind * 100) / total;
  return [remindPercent, 100 - remindPercent];
}

function getOptions() {
  const animation: _DeepPartialObject<AnimationSpec<"doughnut">> = {
    duration: 500,
    easing: "easeInCubic",
  };
  const options = {
    cutout: "80%",
    responsive: false,
    legend: {
      display: false,
    },
    animation,
    tooltip: {
      enabled: false,
    },
  };
  return options;
}
